import { EnergyType } from 'types/producer'
import { IconName } from '@boltenergy-be/design-system'

export const ENERGY_TYPE_ICONS: Record<EnergyType, IconName> = {
  [EnergyType.SOLAR]: 'sun',
  [EnergyType.WATER]: 'water',
  [EnergyType.WIND]: 'wind',
  [EnergyType.BIO]: 'leaf'
}
